import type {ReactNode} from 'react';
import {Paper, Text, UnstyledButton} from '@mantine/core';

/**
 * Clickable card that toggles a selected visual state — for choosing one
 * option among several (radio-card pattern).
 * @registry Selectable card with label/description, selected border+background.
 *
 * Ported from `library-m/forms/SelectableCard`. Prop surface kept identical.
 */
export interface SelectableCardProps {
  label: string;
  description?: string;
  value: string;
  selected: boolean;
  onClick: (value: string) => void;
  icon?: ReactNode;
  disabled?: boolean;
}

export const SelectableCard = ({
  label,
  description,
  value,
  selected,
  onClick,
  icon,
  disabled,
}: SelectableCardProps) => {
  return (
    <UnstyledButton
      onClick={() => onClick(value)}
      w="100%"
      disabled={disabled}>
      <Paper
        withBorder
        p="md"
        style={{
          borderWidth: 2,
          borderColor: selected
            ? 'var(--mantine-primary-color-filled)'
            : 'var(--mantine-color-gray-3)',
          background: selected
            ? 'var(--mantine-primary-color-light)'
            : 'var(--mantine-color-body)',
          transition: 'all 0.2s ease',
          opacity: disabled ? 0.6 : 1,
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}>
        {icon && <>{icon}</>}
        <Text fw={600} size="sm">
          {label}
        </Text>
        {description && (
          <Text size="xs" c="dimmed" mt={4}>
            {description}
          </Text>
        )}
      </Paper>
    </UnstyledButton>
  );
};
